import { z } from 'zod'
import { optionalEmail, optionalText } from './common'

const clientFields = z.object({
  hebrewFirstName: optionalText(100),
  hebrewLastName: optionalText(100),
  firstName: optionalText(100),
  lastName: optionalText(100),
  nationalId: optionalText(20),
  passport: optionalText(30),
  country: optionalText(100),
  email: optionalEmail(),
  phone: optionalText(40),
  entityNumber: optionalText(40),
})

/** Used for both create and update — the client form always submits every field. */
export const clientInputSchema = clientFields.superRefine((v, ctx) => {
  if (!v.hebrewFirstName && !v.hebrewLastName && !v.firstName && !v.lastName) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['hebrewFirstName'],
      message: 'חובה למלא שם בעברית או שם באנגלית',
    })
  }
  if (!v.nationalId && !v.passport) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['nationalId'],
      message: 'חובה למלא מספר תעודת זהות או מספר דרכון',
    })
  }
})

export type ClientInput = z.infer<typeof clientInputSchema>

export const clientQuerySchema = z.object({
  search: optionalText(200),
})

export type ClientQuery = z.infer<typeof clientQuerySchema>

export type ClientDto = {
  id: string
  hebrewFirstName: string | null
  hebrewLastName: string | null
  firstName: string | null
  lastName: string | null
  /** Full names, "first last" — derived by the server, never sent. */
  name: string | null
  hebrewName: string | null
  nationalId: string | null
  passport: string | null
  country: string | null
  email: string | null
  phone: string | null
  entityNumber: string | null
  driveFolderId: string | null
  createdAt: string
  updatedAt: string
}
